import { useSelector } from 'react-redux';
import { Circle, Flex, SquareProps, Text } from '@chakra-ui/react';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  CloseIcon,
  DeleteIcon,
  EditIcon,
} from '@chakra-ui/icons';
import { entries } from 'lodash';
import { ReactNode } from 'react';
import { IconType } from 'react-icons';
import { BiColumns } from 'react-icons/bi';
import * as hiIcons from 'react-icons/hi2';
import { IoMdLogOut } from 'react-icons/io';
import { TState } from '../../redux/store';

export const CirlceIcon = ({
  icon,
  color,
  boxSize,
  label,
  disabled,
  ...props
}: SquareProps & {
  icon?: ReactNode;
  boxSize?: string | number;
  disabled?: boolean;
  label?: string;
}) => {
  const theme = useSelector((state: TState) => state.theme);
  const textColor = color || theme.dark;

  return (
    <Circle
      boxSize={label ? 'auto' : boxSize || theme.fontSize.headerBig}
      padding={'5px'}
      px={label ? '10px' : '5px'}
      color={textColor}
      mx={0.5}
      _hover={{
        ...props._hover,
      }}
      {...props}
      bgColor={props.backgroundColor || props.bgColor || theme.btnBg}
      cursor={props.onClick && !disabled ? 'pointer' : 'default'}
      onClick={disabled ? undefined : props.onClick}
      opacity={disabled ? 0.5 : 1}
      gap={1}
    >
      {label ? (
        <Text color={textColor} fontSize={props.fontSize}>
          {label}
        </Text>
      ) : null}
      {icon}
    </Circle>
  );
};

export const NormalIcon = ({
  icon,
  color,
  boxSize,
  label,
  disabled,
  ...props
}: SquareProps & {
  icon?: ReactNode;
  boxSize?: string | number;
  disabled?: boolean;
  label?: string;
}) => {
  const theme = useSelector((state: TState) => state.theme);

  return (
    <Flex gap={2}>
      <Circle
        boxSize={boxSize || theme.fontSize.header}
        color={color || theme.dark}
        mx={0.5}
        _hover={{
          ...props._hover,
        }}
        cursor={
          disabled
            ? 'default'
            : props.onClick
              ? 'pointer'
              : props.cursor
                ? props.cursor
                : 'default'
        }
        {...props}
        onClick={disabled ? undefined : props.onClick}
        opacity={disabled ? 0.5 : 1}
      >
        {icon}
      </Circle>
      {label ? (
        <Text mr={2} fontSize={theme.fontSize.small}>
          {label}
        </Text>
      ) : null}
    </Flex>
  );
};

export const icons = {
  logout: IoMdLogOut,
  edit: EditIcon,
  cross: CloseIcon,
  arrowUp: <ChevronUpIcon />,
  arrowDown: <ChevronDownIcon />,
  trash: <DeleteIcon />,
  page: BiColumns,
  column: hiIcons.HiViewColumns,
  duplicate: <hiIcons.HiOutlineDocumentDuplicate />,
};

export const allIcons: Record<string, IconType> = hiIcons;

export const pageIcons: Record<string, IconType> = entries(hiIcons).reduce(
  (prev, [key, value]) =>
    /Outline/.test(key) ? prev : { ...prev, [key]: value },
  {},
);
